<template>
  <div id="remit">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        style="padding: 0 5px"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item :label="`${$t('shopName')}：`" class="item">
                <div
                  style="max-height: 200px;overflow-y: auto; float: left;
                    width: calc(100% - 59px);"
                >
                  <el-input
                    v-if="isExpand"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="shopName"
                    size="small"
                    :placeholder="`${$t('shopName')}`"
                  ></el-input>
                  <el-checkbox @change="handleChangeShop" v-model="isCheckShop"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="form.shopId"
                    placeholder="请选择店铺名称"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(item, index) in shopList"
                      :key="index"
                      :label="item.shopId"
                      v-show="
                        (isExpand || index < 10) &&
                          item.shopName.indexOf(shopName) > -1
                      "
                    >
                      {{ item.shopName
                      }}<span v-if="item.amazonSite"
                        >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                      >
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="shopList.length > 10"
                  @click="isExpand = !isExpand"
                  style="margin: 0 0 0 16px; cursor: pointer; color: #4934b2;float:left;"
                >
                  {{ isExpand ? `－${$t('collapse')}` : `＋${$t('expand')}` }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item :label="`${$t('productCode')}`" prop="pId">
                <el-input
                  clearable
                  v-model="form.pId"
                  placeholder=""
                  size="small"
                  style="width: 100%"
                >
                </el-input>
              </el-form-item></div
          ></el-col>
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item :label="`${$t('time')}：`">
                <el-date-picker
                  size="small"
                  v-model="downloadTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  :start-placeholder="$t('startDate')"
                  :end-placeholder="$t('endDate')"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item></div
          ></el-col>
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item :label="`${$t('operator')}：`" prop="operNo">
                <el-input
                  clearable
                  v-model="form.operNo"
                  placeholder=""
                  size="small"
                  style="width: 100%"
                >
                </el-input>
              </el-form-item></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item :label="`${$t('syncStatus')}：`" prop="syncStatus">
                <el-select
                  clearable
                  v-model="form.syncStatus"
                  placeholder="请选择"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(value, key, index) in dictData['syncStatus']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                    >{{ $enTitle(value.label) }}
                  </el-option>
                </el-select>
              </el-form-item>
            </div></el-col
          >
          <el-col :span="16"
            ><div class="grid-content bg-purple" style="text-align: right">
              <el-button size="small" type="primary" @click="getList"
                >{{$t('search')}}</el-button
              >
              <el-button size="small" @click="resetForm">{{$t('reset')}}</el-button>
            </div></el-col
          >
        </el-row>
      </el-form>
    </div>
    <div class="table-body">
      <div class="table-menu" style="overflow: hidden;margin: 0px 0 16px 0;">
        <div class="left">
          <el-button
            type="primary"
            size="small"
            @click="syncOrder('1')"
            v-if="user.userType !== '00'"
          >
            {{$t('publishNow')}}
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="syncOrder('2')"
            v-if="user.userType !== '00'"
          >
            {{$t('schedulePublish')}}
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="cancelOrder()"
            v-if="user.userType !== '00'"
          >
            {{$t('cancelSchedule')}}
          </el-button>
          <el-button
            style="margin: 0 0 0 16px;"
            type="danger"
            size="small"
            @click="batchDelete"
            >{{$t('bulkDelete')}}</el-button
          >
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="form.pageNum"
          :limit.sync="form.pageSize"
          @pagination="getList"
        />
      </div>

      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        border
      >
        <el-table-column type="selection" width="55" align="center" />

        <el-table-column
          :label="$t('product')"
          width="200px"
          align="center"
          prop="designId"
        >
          <template slot-scope="scope">
            <div>
              <el-tooltip placement="right" effect="light">
                <div slot="content">
                  <img
                    :src="scope.row.mainPic"
                    style="width:300px;height:300px;margin: 0 0 0 5px;"
                  />
                </div>
                <img
                  style="width:100px;height:100px;margin: 0 0 0 5px;"
                  :src="scope.row.mainPic"
                />
              </el-tooltip>
            </div>
            <span
              @click="handleJumpDesign(scope.row)"
              class="el-button--text"
              style="cursor: pointer"
              >{{ scope.row.pId }}</span
            >
            <i
              title="复制"
              class="el-icon-document-copy"
              style="cursor: pointer;margin: 0 0 0 4px;"
              @click="copyText(scope.row.pId)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column
          label="sellerSku"
          header-align="center"
          align="left"
          prop="itemSku"
          width="200"
        >
          <template slot-scope="scope">
            <div
              v-if="!scope.row.expand && index < 4"
              :title="scope.row.itemSku"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.itemSku }}
            </div>
            <div
              v-if="scope.row.expand"
              :title="scope.row.itemSku"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.itemSku }}
            </div>
            <div v-if="scope.row.skuList.length > 4">
              <span
                @click="handleExpand(scope.row)"
                style="color:#4934b2;cursor:pointer;"
                >{{ scope.row.expand ? $t('collapse') : $t('expand') }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('color')"
          header-align="center"
          align="left"
          prop="color"
          width="100"
        >
          <template slot-scope="scope">
            <div
              v-if="!scope.row.expand && index < 4"
              :title="scope.row.color"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.color }}
            </div>
            <div
              v-if="scope.row.expand"
              :title="scope.row.color"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.color }}
            </div>
            <div v-if="scope.row.skuList.length > 4">
              <span
                @click="handleExpand(scope.row)"
                style="color:#4934b2;cursor:pointer;"
                >{{ scope.row.expand ? $t('collapse') : $t('expand') }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('size')"
          header-align="center"
          align="left"
          prop="size"
          width="100"
        >
          <template slot-scope="scope">
            <div
              v-if="!scope.row.expand && index < 4"
              :title="scope.row.size"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.size }}
            </div>
            <div
              v-if="scope.row.expand"
              :title="scope.row.size"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.size }}
            </div>
            <div v-if="scope.row.skuList.length > 4">
              <span
                @click="handleExpand(scope.row)"
                style="color:#4934b2;cursor:pointer;"
                >{{ scope.row.expand ? $t('collapse') : $t('expand') }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('price')"
          header-align="center"
          align="left"
          width="100"
          prop="price"
        >
          <template slot-scope="scope">
            <div
              v-if="!scope.row.expand && index < 4"
              :title="scope.row.price"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.price }}
            </div>
            <div
              v-if="scope.row.expand"
              :title="scope.row.price"
              class="text-ellipsis"
              style="width:280px;"
              v-for="(record, index) in scope.row.skuList"
              :key="index"
            >
              {{ record.price }}
            </div>
            <div v-if="scope.row.skuList.length > 4">
              <span
                @click="handleExpand(scope.row)"
                style="color:#4934b2;cursor:pointer;"
                >{{ scope.row.expand ? $t('collapse') : $t('expand') }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('store')" align="center" prop="shopName" />
        <el-table-column
          :label="$t('operator')"
          align="center"
          prop="nickName"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.nickName ? scope.row.nickName : scope.row.operNo }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('time')"
          align="center"
          prop="remitTime"
          width="170"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.remitTime }} </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('syncStatus')"
          width="100px"
          align="center"
          prop="syncStatus"
        >
          <template slot-scope="scope">
            <div>
              {{ $enTitle(dictMap["syncStatus"][scope.row.syncStatus]) }}
              <span
                v-if="dictMap['syncStatus'][scope.row.syncStatus] == '发布失败'"
              >
                <el-tooltip class="item" effect="dark" placement="top">
                  <div style="width:300px;" slot="content">
                    {{ scope.row.errorMsg }}
                  </div>
                  <i style="color:red;" class="el-icon-warning"></i>
                </el-tooltip>
              </span>
            </div>
            <div v-if="scope.row.autoTime && scope.row.syncStatus == '04'">
              {{ scope.row.autoTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="handel" :label="$t('operation')" align="center" width="100">
          <template slot-scope="scope">
            <p v-if="dictMap['syncStatus'][scope.row.syncStatus] == '已发布'">
              <el-button type="text" size="mini" @click="handleView(scope.row)"
                >查看
              </el-button>
            </p>
            <p
              v-if="
                dictMap['syncStatus'][scope.row.syncStatus] == '待发布' ||
                  dictMap['syncStatus'][scope.row.syncStatus] == '发布中' ||
                  dictMap['syncStatus'][scope.row.syncStatus] == '发布失败'
              "
            >
              <el-button type="text" size="mini" @click="handleEdit(scope.row)"
                >{{$t('edit')}}
              </el-button>
            </p>
            <p>
              <el-button
                type="text"
                size="mini"
                @click="handleDelete(scope.row)"
                >{{$t('delete')}}
              </el-button>
            </p>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getList"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="下载文件名称设置"
      width="35%"
      :visible.sync="noteDialogVisible"
      class="note-dialog"
    >
      <el-row style="display: flex; align-items: center">
        <el-col :span="2">
          <p>文本名称规则:</p>
        </el-col>
        <el-col :span="22">
          <el-input v-model="form.remark" type="textarea" :rows="6"> </el-input>
        </el-col>
      </el-row>
      <el-row style="display: flex; align-items: center; padding-left: 50px">
        1、下载文件名称可以由变量和常量组成，如设置文件名称：Amz-{StoreName}-{DownloadDate}-{RecordNumber}，下载后文件名称为：Amz-小明精品FBA店-2020220-C7PQ6KK.xlsx；
        <br />2、设置后的文件名称，仅对新下载的文件有效；
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noteDialogVisible = false" size="small"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="submitRemark(form.remark)"
          size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <SyncTiktok
      :syncMode="syncMode"
      :data="selectData"
      :visible="showSyncOrder"
      @onClose="hideSyncOrder"
      @update="updateList"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import {loadZdxz,loadSmxs,updateAmazonRemark,singledeleteAmazon,batchDeleteByIDs,batchdeleteAmazon,getTreeList,lowerShelfProduct,loadRemit,exportRemit} from '@/api/product/amazon'
import {getTree} from '@/api/tree/tree';
import { downLoadExcel } from "@/utils/zipdownload";
import { getRemitList, cancelTiming } from "@/api/template/universal";
import { getShopList } from "@/api/system/shopManage";
import { mapGetters } from "vuex";
import SyncTiktok from "./SyncTiktok"
import { deleteTemplateRemit,deleteTemplateRemits } from "@/api/template/template";

export default {
    name: "remitDataShopee",
    components:{Breadcrumb, SyncTiktok},
    data() {
        return {
            total: 0,
            currentPage: 1,
            pickerOptions: {},
            form: {
              pageNum: 1,
              pageSize: 10,
              syncStatus: '',
              pId: '',
              operNo: '',
              shopId: [],
              remitMode: '02'
            },
            syncMode: '1',
            downloadTime: null,
            remitTime: null,
            tableData: [],
            noteDialogVisible: false,
            shopList: [],
            isCheckShop: true,
            isExpand: false,
            shopName: '',
            platNo: '',
            showSyncOrder: false,
            ids: '',
            selectData: [],
                scrollMenu: '',
            objectHeight: ''
        }

    },
    computed:{
        treeId(){
            return this.$route.query.treeId;
        },
          ...mapGetters(["dictData", "dictMap", "user"]),
           routeName() {
      return this.$route.path
    },
    },
    watch:{
        treeId(){
            this.dateValue=null;
            this.getList()
        },
           routeName() {
      this.getList()
    },
    },
    created() {
        let pageNum = this.$route.query.pageNum
        if(pageNum){
          this.form.pageNum = Number(pageNum)
        }
        this.getList();
        this.getShopList();
        this.$nextTick(() => {
          this.scrollMenu = document.querySelector(".table-menu")
          this.objectHeight = this.scrollMenu.offsetTop
          window.addEventListener("scroll", this.handleScroll)
        })
    },
     destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
    methods: {
        handleScroll() {
      var menu = this.scrollMenu
      //获取页面的滚动距离
      var scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop
      //滚动到一定位置 div固定到顶部 js实现吸顶
      console.log(scrollHeight + "," + this.objectHeight)
      if (this.objectHeight < scrollHeight) {
        menu.style.position = "fixed"
        menu.style.top = 0
        menu.style.width = "calc(100% - 312px)"
        menu.style.padding = "8px 0"
      } else {
        menu.style.position = "relative"
        menu.style.width = "100%"
        menu.style.padding = "0"
      }
    },
        getShopList(){
          getShopList({ platNo: "10" }).then((res) => {
            this.shopList = res.rows
          })
        },
         handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
     syncOrder(syncMode) {
      if(this.ids == ''){
        this.msgError('请选择产品')
        return
      }
      for(let record of this.selectData){
        if(record.syncStatus == '02'){
          this.msgError(record.pId + '已发布，无需同步')
          return;
        }
      }
      this.syncMode = syncMode
      this.showSyncOrder = true
    },
      hideSyncOrder() {
      this.showSyncOrder = false
    },
     async cancelOrder(){
      if(this.ids == ''){
        this.msgError('请选择产品')
        return
      }
      let result = await cancelTiming({remitIds: this.ids})
      this.msgSuccess('取消同步成功')
      this.getList()
    },
        batchDownLoad() {
            this.noteDialogVisible = true;
        },
        async handleDelete(row) {
        this.$confirm("确定删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error",
        })
          .then(async () => {
            await deleteTemplateRemit({remitId: row.remitId})
            this.$message.success("删除成功！")
            this.getList()
          })
          .catch(() => {})
      },
        turnWay(e){
            var classVal =  e.target.className;
            if(classVal == 'el-icon-caret-top'){
                e.target.setAttribute('class','el-icon-caret-bottom');
                this.form.byAsc = 'desc';
            }else{
                e.target.setAttribute('class','el-icon-caret-top');
                this.form.byAsc = 'asc';
            }
            this.getListZz();
        },
        loadNode(node, resolve) {
            var that =this;
            if (node.level === 0) {
                //查询顶级节点
                let params = {};
                getTreeList(params).then(function(res){
                    that.treeData = that.createTreeData(res.data);
                    return resolve(that.treeData);
                }).catch(function(error){
                    this.$message.error(res.msg);
                });
            }else {
                let params = {pTypeNo:node.data.id};
                // 根据父节点id找寻下一级的所有节点
                getTreeList(params).then(res => {
                    return resolve(res.data);
                });
            }

        },

        createTreeData(data){
            let treedata = data.filter(father =>{
                if(father['pTypeNo'] == ""||father['pTypeNo'] == null){
                    father['pTypeNo'] = '0'
                }
                let childArr = data.filter(child =>{
                    return  child['pTypeNo'] == father.id;
                });
                childArr.length > 0?father.children =childArr:'';
                return father['pTypeNo'] == '0';
            });
            return treedata ;
        },

        setClassManage:function(){
            this.classManageDialog = true;
        },

        closeCMDialog_f:function(){
            this.classManageDialog = false;
        },
        show: function() {

        },
        showMoreSearchItem:function(){
            this.showMoreItem = !this.showMoreItem;
        },
        cancle_1:function(){
            this.showMoreItem = false;
        },

        loadSku(tree, treeNode, resolve){
            var xalist =[]

            for (var i =0 ; i<tree.sAmazonSku.length;i++){
                var  aa=
                {
                    bzxs:false,
                    dpxs:false,
                    cz:false,
                    zcd:true,
                    fcd:false,
                    pId: tree.sAmazonSku[i].skuid,
                    mainPic: tree.mainPic,
                    proTitle:tree.proTitle,
                    skuno:tree.sAmazonSku[i].skuno,
                    aSite:tree.aSite,
                    price:tree.sAmazonSku[i].price,
                    invent:tree.sAmazonSku[i].invent,
                    createTime:tree.createTime,
                    updateTime:tree.updateTime
                }
                xalist.push(aa);
            }
            resolve(xalist)
        },
        copyText(text) {
        let target = document.createElement("input") //创建input节点
        target.value = text // 给input的value赋值
        document.body.appendChild(target)
        target.value = text // 修改文本框的内容
        target.select() // 选中文本
        document.execCommand("copy") // 执行浏览器复制命令
        this.msgSuccess("复制成功")
        document.body.removeChild(target)
      },

        getList: function() {
            this.startLoading()
            let form = this._.clone(this.form)
            form.shopId = form.shopId.join(',')

            let path = this.$route.path
            if(path.indexOf('shopfiy') > -1){
              form.platNo = '06'
            } else if(path.indexOf('shopee') > -1){
              form.platNo = '05'
            }else if(path.indexOf('shopline') > -1){
              form.platNo = '07'
            }else if(path.indexOf('shoplazza') > -1){
              form.platNo = '08'
            }else if(path.indexOf('lazada') > -1){
              form.platNo = '03'
            }else if(path.indexOf('tiktok') > -1){
              form.platNo = '10'
            }else {
              form.platNo = '09'
            }
            this.platNo = form.platNo

            if (this.downloadTime !=null){
              form.beginTime=this.downloadTime[0];
              form.endTime=this.downloadTime[1];
            } else{
              form.beginTime=  undefined
              form.endTime= undefined
            }

            getRemitList(form).then((response) => {
                for (let record of response.rows) {
                  if(!record.syncStatus){
                    record.syncStatus = '01'
                  }
                  record.expand = false
                  if (record.skuList) {
                    for (let product of record.skuList) {
                      record.designId = product.designId
                    }
                  }
                }
                this.total = response.total
                this.tableData = response.rows
                this.endLoading()
            })
            this.$router.push({path: '/carry/tiktok/remitDataTiktok', query: {pageNum : form.pageNum}})
        },
        async handleDownload(row) {
          this.startLoading()
          let method = 'exportRemit'
          let path = this.$route.path
          if(path.indexOf('shopfiy') > -1 || path.indexOf('shopline') > -1 || path.indexOf('shoplazza') > -1){
            method = 'exportTemplateRemit'
          }

          downLoadExcel(`/server/universal/template/${method}?remitId=${row.remitId}&fileName=` + Math.random(), Math.random()).then(()=>{
            this.getList()
            this.endLoading()
          })
        },
        updateList(){
          this.hideSyncOrder()
          this.getList()
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
          if (
            columnIndex === 0 ||
            columnIndex === 1 ||
            columnIndex === 8||
            columnIndex === 9||
            columnIndex === 10||
            columnIndex === 11
          ) {
            if (row.isNew && row.count != 0) {
              return {
                rowspan: row.count,
                colspan: 1,
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0,
              }
            }
          }
        },
        getZdxz: function() {
            this.startLoading()
            loadZdxz().then((res) => {
                this.dpzdxzList = res.rows;
                this.endLoading()
            })
        },
        getSmxs: function() {
            this.loading = true;
            loadSmxs().then((res) => {
                this.dpsmxsList = res.rows;
                this.endLoading()
            })
        },
         handleEdit(row){
          let names = []
          for(let record of row.skuList){
            names.push(record.productName)
            break
          }
          this.$router.push({path:`/carry/common/createTemplateData?remitId=${row.remitId}&skuNum=${row.remitSkuNum}&name=${names.join('，')}&platName=tiktok&platId=tiktok&platNo=10&upload=1`})
        },
        handleView(row){
          let names = []
          for(let record of row.skuList){
            names.push(record.productName)
            break
          }
          this.$router.push({path:`/carry/common/createTemplateData?remitId=${row.remitId}&skuNum=${row.remitSkuNum}&name=${names.join('，')}&platName=tiktok&platId=tiktok&platNo=10&upload=1&isView=1`})
        },


        setDownLoadFileName(){
            this.noteDialogVisible=true
        },


        //提交备注
        submitRemark(remark){
            updateAmazonRemark(this.form).then((res) => {
                if (res.code === 200) {
                    this.msgSuccess("修改成功");
                    this.getList();
                    this.noteDialogVisible = false;
                }
            })
        },
        handleExpand(row) {
          row.expand = !row.expand
        },
        batchHandle: function(val) {
            if ("1" == val) {
                //将亚马逊平台商品同步到本平台

            } else if("2"== val) {
                // this.batchUpdate();
                this.batchLowerShelfProduct();
            }else {
                this.batchDelete();
            }
        },
        //批量删除
        batchDelete() {
            const ids =this.ids;
            if(ids.length == 0){
              this.msgError('请选择数据')
              return
            }
            this.$confirm('是否确认删除选择的' + ids.split(',').length + '条数据项?', "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function() {
                return deleteTemplateRemits({remitIds: ids});
            }).then(() => {
                this.getList();
                this.msgSuccess("删除成功");
            }).catch(function() {});
        },
        async  handleJumpDesign(row){
            let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { designId: row.designId }} );
            window.open(routeUrl.href, '_blank');
        },
//            批量待发布
        batchUpdate() {
            const shopeeList = this.shopeeList;
            if (this.shopeeList.length==0){
                this.msgError("批量待发布至少选择一条数据");
                return
            }
            this.$confirm('是否确认把这' + this.shopeeList.length + '条数据项批量移入待发布', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function() {
                return batchDeleteByIDs(JSON.stringify(shopeeList));
            }).then(() => {
                this.getList();
                this.msgSuccess("修改成功");
            }).catch(function() {});
        },

        //用户勾选
        handleSelectionChange(val) {
            let ids=[];
            val.forEach((item) => {
                ids.push(item.remitId);
            });
            this.ids = ids.join(',')
            this.selectData = val
        },

        foramtDataSource(val){
            if(val == '01'){
                return "1688";
            }else if(val == '02'){
                return "速卖通";
            }else if(val == '03'){
                return "Lazada";
            } else if(val == '04'){
                return "Amazon";
            } else if(val == '05'){
                return "Shopee";
            }
            return "未知";
        },


        handleSizeChange: function(val) {
            console.log(`每页: ${val}条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        edit: function(row) {
            this.$router.push({path: "/product/amazon/onLineEdit", query: {pId: row.pId}})
        },
        deleteRow(row) {
//                let pId = row.pId;
            this.$confirm('是否确认删除Amazon产品标题为<span style="color: red">' + row.proTitle + '</span>的数据项?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                //显示HTML
                dangerouslyUseHTMLString: true,
                type: "warning"
            }).then(function() {
                return singledeleteAmazon(row.pId);
            }).then(() => {
                this.getList();
                this.msgSuccess("删除成功");
            }).catch(function() {});
        },
        //清空表单
        resetForm(){
            this.form.shopId = []
            this.form.syncStatus = ''
            this.form.operNo = ''
            this.form.designId = ''
            this.form.operNo = ''
            this.downloadTime = null
        },
        //移动分类树形数据
        getMoveClassification(that){
            getTree().then((res) => {
                this.ydlfTree.treeData=res.data;
            })
        },
        //批量下架产品
        batchLowerShelfProduct(){
            var length = this.ids.length;
            var join = this.ids.join("-");
            if (length <=0){
                this.msgError("请选择需要下架的产品");
                return;
            }
            this.$confirm('是否确认把这'+length+'条产品下架?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function() {
                return lowerShelfProduct(join);
            }).then(() => {
                this.getList();
                this.msgSuccess("下架产品成功");
            }).catch(function() {});
        },
        importDefiMode(){

        },
        addSysTem(){

        },
        addDefiOrder(){

        }
    },
    mounted() {

    }
}
</script>

<style scoped>
@import "../../../assets/css/product.css";
#ready-release {
  width: 100%;
}
.detailForm {
  padding-top: 5px;
  margin-left: 85px;
  width: 50%;
  height: auto;
  margin-bottom: 8px;
}
.detailForm .el-form-item,
.sea_cont {
  margin-bottom: 10px !important;
}
.double_item .el-form-item {
  margin-bottom: 0px !important;
}
.scro >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.table-menu {
  width: 100%;
  z-index: 100;
  background: #ffffff;
}
</style>
